import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import {CoreAuthenticationService,CoreUserProfileService} from "@ftr/owa-core";
import { TimekeepingService } from '@ftr/owa-timekeeping';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AlertModel, CommonAlertComponent } from '@ftr/common-ui-components';

@Injectable()
export class LoginGuard  {
    private _coreAuthenticationService = inject(CoreAuthenticationService);
    private router = inject(Router);
    private _timeService = inject(TimekeepingService);
    private _dialog = inject(MatDialog);
    private _coreuserProfileService = inject(CoreUserProfileService);

    isContractor: boolean = true;

    constructor() {
            this.isContractor = this._coreuserProfileService.isContractor;
    }

    async canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Promise<true | UrlTree> {
        if (this.isContractor && next.data.role && next.data.role === 'CONTRACTOR' && !next.data['omegaMode']) {
            this.router.navigate(['/home']);
        }
        if(!this._coreAuthenticationService.isAuthenticated)
        await this._coreAuthenticationService.validateAuth();
        if (this._coreAuthenticationService.isAuthenticated) {
            return true;
        }
        return this.router.parseUrl("/login")
    }
}